import {gql} from '@apollo/client';

export const lookupMutations = {
    CREATE_LOOKUP: gql`
        mutation ($input: LookUpViewModelInput!) {
            createLookUp(input: $input) {
                id
                title
                data
                category
                parentId
                type
                description
                active
            }
        }
    `,
    UPDATE_LOOKUP: gql`
        mutation ($input: LookUpInput!) {
            updateLookUp(input: $input) {
                id
                title
                data
                category
                parentId
                type
                description
                active
            }
        }
    `,
    REMOVE_LOOKUP_BY_ID: gql`
        mutation ($id: UUID!) {
            removeLookUpById(id: $id) {
                statusCode
                message
                success
                data
            }
        }
    `,
    REMOVE_LOOKUPS_BY_IDS: gql`
        mutation ($ids: [UUID!]!) {
            removeLookUpsByIds(ids: $ids) {
                statusCode
                message
                success
                data
            }
        }
    `,
    CHANGE_LOOKUP_STATUS: gql`
        mutation ($id: UUID!, $status: Boolean!) {
            changeLookupStatus(id: $id, status: $status) {
                statusCode
                message
                success
                data
            }
        }
    `,
    UPLOAD_LOOKUP_DATA: gql`
        mutation UploadLookupData($file: Upload!) {
            uploadLookupData(file: $file) {
                statusCode
                message
                success
                data
            }
        }
    `,
};
